import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type MutationInput = {
  clientId?: string;
  documentId: string;
};

const CLIENT_SCOPED_PATHS = new Set(['data-exports', 'suitability-reports']);

export function useDeleteDocument(documentTypePath: string) {
  const queryClient = useQueryClient();
  const isClientScoped = CLIENT_SCOPED_PATHS.has(documentTypePath);

  const {
    mutateAsync,
    error,
    isPending: isLoading,
    reset,
  } = useMutation<unknown, Error, MutationInput>({
    mutationFn: ({ clientId, documentId }: MutationInput) =>
      isClientScoped
        ? api.delete(`clients/${clientId}/${documentTypePath}/${documentId}`)
        : api.delete(`${documentTypePath}/${documentId}`),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [documentTypePath] });
      queryClient.invalidateQueries({ queryKey: ['clients'] });
    },
  });

  const deleteDocument = async (clientId: string | undefined, documentId: string) => {
    return mutateAsync({ clientId, documentId });
  };

  return {
    deleteDocument,
    error,
    isLoading,
    reset,
  };
}
